import { type AppState } from 'src/core/reducers';

import { type TermsAndConditions } from './types';
import { type AccountLoad } from '../wallet';

export const getAccountLoads = (state: AppState): AccountLoad[] => {
  return state.wallet.loads;
};

export const getIsLoadingAccountLoads = (state: AppState): boolean => {
  return state.wallet.behavior.isAccountLoadsLoading;
};

export const getLastTermsAndConditions = (
  state: AppState,
): TermsAndConditions | null => {
  return state.controllerHomepage.lastTermsAndConditions;
};
